<template>
  <el-dialog :title="$t('message.面试结果确认')" :visible.sync="innerVisible" width="35%" center>
    <div class="center">
      <span>
        {{ this.interview.custom_name }}同学，于
        <i>{{ interviewDate }}</i>进行面试。
      </span>
      <div>
        <h4>{{ $t('message.面试结果') }}</h4>
        <el-radio-group v-model="form.interview_result">
          <el-radio
            border
            v-for="result in interviewResult"
            :label="result.value"
            :key="result.value"
          >{{ result.label }}</el-radio>
        </el-radio-group>
      </div>
      <div v-show="form.interview_result === 3">
        <h4>{{ $t('message.合格条件') }}</h4>
        <el-input
          type="textarea"
          ref="conditionMemo"
          :rows="4"
          :placeholder="$t('message.请您填写合格的条件')"
          v-model="form.qualified_condition"
        />
      </div>
      <div class="upload-wrap" v-show="form.interview_result !== 2">
        <h4>{{ $t('message.合格证') }}</h4>
        <jm-asset-upload
          :file-list.sync="fileList"
          accept=".pdf, .jpg, .jpeg, .png"
          @upload-success="uploadSuccess"
          :on-remove="removeResultFile"
        >
          <el-button type="primary">{{ $t('message.点击上传') }}</el-button>
        </jm-asset-upload>
      </div>
      <div>
        <el-input
          type="textarea"
          :rows="4"
          v-model="form.interview_memo"
          :placeholder="$t('message.请您填写备注')"
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="btn-close-dialog" type="primary" @click="close">{{ $t('message.关闭') }}</el-button>
      <el-button class="btn-save-dialog" type="primary" @click="saveResult">{{ $t('message.保存') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { interviewWay, interviewResult } from '../../dataset/interview';
import dialogMixin from './dialogMixin';
import { jmAssetUpload } from '@/components/tool';

export default {
  mixins: [dialogMixin],
  components: {
    jmAssetUpload
  },
  props: {
    interview: {
      type: Object,
      require: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      interviewWay,
      interviewResult,
      form: {
        interview_way: '',
        interview_result: '',
        qualified_condition: '',
        interview_memo: '',
        asset_id: null,
        result_pdf: null
      },
      fileList: []
    };
  },
  computed: {
    interviewDate() {
      return this.interview.interview_time;
    },
    cannotSave() {
      if (!this.isInterviewer) {
        return true;
      }
      if (this.form.interview_result === 3 && !this.form.qualified_condition) {
        return true;
      }
      if (this.hasResult) {
        return true;
      }
      return false;
    },
    hasResult() {
      return !!this.form.originResult;
    },
    isInterviewer() {
      return this.$hasPermission([108], true);
    }
  },
  watch: {
    'form.interview_result'(v) {
      if (v === 3) {
        this.$nextTick(() => {
          this.$refs.conditionMemo.focus();
        });
      }
    },
    interview(v) {
      if (v) {
        this.setFileList(v.asset);
        this.form = { ...this.form, ...v, originResult: v.interview_result };
      }
    }
  },
  methods: {
    setFileList(file) {
      this.fileList = file
        ? [{ name: file.filename, url: file.file_path }]
        : [];
    },
    async saveResult() {
      await this.$http._post({
        url: '/interview/plan/saveResult',
        data: { data: this.form }
      });
      this.$message.success(this.$t('message.保存面试结果成功'));
      this.innerVisible = false;
    },
    async uploadSuccess(data) {
      this.setFileList(data);
      this.form.asset_id = data.id;
      this.form.result_pdf = data.file_path;
      await this.$http._post({
        url: '/interview/plan/setInterviewPaper',
        data: {
          id: this.interview.id,
          assetId: data.id,
          pdf: data.file_path
        }
      });
    },
    removeResultFile() {
      this.form.asset_id = null;
      this.form.result_pdf = null;
    }
  }
};
</script>
<style scoped>
.center {
  text-align: center;
}
.center h4 {
  font-size: 20px;
  padding: 10px;
}
</style>
